import React, { useState, useEffect, useMemo, useCallback } from "react";
import "./Gallery.css";

const galleryImages = [
  { id: 1, src: "gellary/Cover.jpg", title: "Cover Image", category: "General" },
  { id: 2, src: "gellary/A-to-Z.jpg", title: "A to Z Services", category: "Services" },
  { id: 3, src: "gellary/Bmet.jpg", title: "BMET Services", category: "Services" },
  { id: 4, src: "gellary/Hajj.jpg", title: "Hajj Services", category: "Religious" },
  { id: 5, src: "gellary/Jiyara-visda.jpg", title: "Jiyara Visa", category: "Visa" },
];

const categories = ["All", "General", "Services", "Religious", "Visa", "Office"];

const GalleryItem = React.memo(({ image, index, onOpen }) => (
  <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.1}s`}>
    <div className="gallery-item" onClick={() => onOpen(image)}>
      <img
        src={image.src}
        alt={image.title}
        className="img-fluid"
        loading="lazy"
        decoding="async"
        onError={(e) => {
          e.target.style.display = "none";
          e.target.parentElement.style.display = "none";
        }}
      />
      <div className="gallery-overlay">
        <div className="gallery-content">
          <h5>{image.title}</h5>
          <span className="badge bg-primary">{image.category}</span>
          <i className="fas fa-search-plus"></i>
        </div>
      </div>
    </div>
  </div>
));

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredImages = useMemo(() => {
    return filter === "All" 
      ? galleryImages 
      : galleryImages.filter((img) => img.category === filter);
  }, [filter]);

  const openModal = useCallback((image) => {
    setSelectedImage(image);
  }, []);

  const closeModal = useCallback(() => {
    setSelectedImage(null);
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape") closeModal();
  }, [closeModal]);

  useEffect(() => {
    if (selectedImage) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "unset";
    };
  }, [selectedImage, handleKeyDown]);

  return (
    <>
      {/* Header */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-2"
          style={{ maxWidth: "900px" }}
        >
          <h3
            className="text-white display-3 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Our Gallery
          </h3>
          <p className="mb-0 text-white">
            Explore our office spaces, services, and memorable moments
          </p>
        </div>
      </div>

      {/* Gallery Content */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="gallery-filters mb-4">
              {categories.map((category) => (
                <button
                  key={category}
                  className={`filter-btn ${
                    filter === category ? "active" : ""
                  }`}
                  onClick={() => setFilter(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          <div className="row g-4">
            {filteredImages.map((image, index) => (
              <GalleryItem
                key={image.id}
                image={image}
                index={index}
                onOpen={openModal}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={closeModal}>
              &times;
            </span>
            <img src={selectedImage.src} alt={selectedImage.title} />
            <div className="modal-info">
              <h4>{selectedImage.title}</h4>
              <span className="badge bg-primary">{selectedImage.category}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
